<template>
  <div class="cp-outer">
    <div class="cp-inner">
      <div class="wrapper">
        <PlainHeader></PlainHeader>
        <ResultContainer headerImage="/assets/img/bad-credentials-header.png">
          <router-view></router-view>
        </ResultContainer>
        <MainFooter></MainFooter>
      </div>
    </div>
  </div>
</template>

<script>
import PlainHeader from '../templates/PlainHeader';
import ResultContainer from '../templates/ResultContainer';
import MainFooter from '../templates/MainFooter';

export default {
  name: 'BadCredentials',

  components: {
    PlainHeader,
    ResultContainer,
    MainFooter
  },

  data() {
    return {
      password: {
        value: '',
        hasError: false,
        placeholder: 'Passwort eingeben'
      }
    };
  },

  computed: {
    passwordReminderURL() {
      return 'paths' in window.Jobpassion ? window.Jobpassion.paths.passwordReminder : '';
    },
    username() {
      return window.Jobpassion.lastUsername;
    }
  },

  methods: {
    onSubmit() {
      const request = document.createElement('input');
      request.type = 'hidden';
      request.name = '_csrf_token';
      request.value = window.security.csrf_token;
      this.$refs.form.appendChild(request);
      this.$refs.form.submit();
    }
  }
};
</script>

<style lang="scss" scoped>
.login-form-wrapper {
  margin-top: 26px;
}

.form-note a {
  color: #9b9b9b;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
}

.animated-label-passwordfield {
  padding: 0;
}
</style>
